import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgTriangleArrowDownRightCircle = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M12 2c-3.17 0-5.715.793-7.461 2.539S2 8.829 2 12c0 3.17.793 5.715 2.539 7.461S8.829 22 12 22c3.17 0 5.715-.793 7.461-2.539S22 15.171 22 12c0-3.17-.793-5.715-2.539-7.461S15.171 2 12 2M8.293 9.707a1 1 0 0 1 1.414-1.414l3.043 3.043 1.543-1.543A1 1 0 0 1 16 10.5V15a1 1 0 0 1-1 1h-4.5a1 1 0 0 1-.707-1.707l1.543-1.543z'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgTriangleArrowDownRightCircle)
export default ForwardRef
